// import React, { Component } from 'react'
import PresetBuilder from './PresetBuilder'

let preset = {}

export function newPreset(param){
  preset = new PresetBuilder()
  // sets preset index
  console.log('>> malletStation Editor - building preset:', ...param.values);
  // preset.add(param)
}

export function addToPreset(presetChunk){
  // if(presetChunk.param === 'name') console.log('>> build preset param', presetChunk.values[0]);
  preset.add(presetChunk)
}

export function getPreset(){
  const builtPreset = preset.get()

  // reset preset
  preset = null

  return builtPreset
}
/*
export class BuildPreset {
  constructor() {
    this._preset = new PresetBuilder()
  }

  addToPreset(param) {
    this._preset.add(param)
  }

  getPreset() {
    return this._preset.get()
  }
}
*/
/*
class PresetBulding extends Component {
  state = {
    preset: {}
  }

  newPreset(param) {
    this.setState({
      preset: new PresetBuilder()
    })
    // sets preset index
    console.log('>> building preset', ...param.values);
    preset.add(param)

    this.setState({
      preset: preset.get()
    })
  }

  addToPreset() {
    preset.add(param)

    this.setState({
      preset: preset.get()
    })
  }

  getPreset() {

  }
}
*/
